const DRAGOON_TAGS = {
  CLIENT_DOCUMENTS_WHITE_LIST: 'CLIENT_DOCUMENTS_WHITE_LIST',
} as const;

type DragoonTag = (typeof DRAGOON_TAGS)[keyof typeof DRAGOON_TAGS];

const ALL_TAGS: DragoonTag[] = [
  DRAGOON_TAGS.CLIENT_DOCUMENTS_WHITE_LIST,
] as const;

export { ALL_TAGS, DRAGOON_TAGS };
